import { Component, inject, input, OnDestroy, OnInit, output } from "@angular/core";
import { Button } from "../button/button";
import { SafeHtmlPipe } from "src/app/shared/pipes/safe-html.pipe";
import { TranslocoModule } from "@jsverse/transloco";
import { ModalService } from "src/app/core/services/modal-service";

@Component({
  selector: "app-modal",
  imports: [Button, SafeHtmlPipe, TranslocoModule],
  templateUrl: "./modal.html",
})
export class Modal implements OnInit, OnDestroy {
  private readonly modalService = inject(ModalService);

  title = input.required<string>();
  image = input<string>("");
  text = input<string>("");
  showClose = input<boolean>(true);
  type = input<"primary" | "secondary">("primary");
  buttonText = input.required<string>();

  completeModal = output<void>();
  closeModal = output<void>();

  ngOnInit(): void {
    this.modalService.register();
  }

  ngOnDestroy(): void {
    this.modalService.unregister();
  }
}
